var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('iframe',{style:({ width: '100%', height: _vm.heightComponent }),attrs:{"src":_vm.iframeSrc,"frameborder":"0"},on:{"load":_vm.adjustHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }